function scriptDirective(halClient) {
    'ngInject';

    return {
        transclude: false,
        restrict: 'E',
        link(scope, element, attrs) {
            if (attrs.type === 'text/hal-object') {
                const body = element[0].innerText;
                const json = $bbug.parseJSON(body);
                halClient.$parse(json);
            }
        }
    };
}

angular
    .module('BB')
    .directive('script', scriptDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/script/script.directive.js